import { type ChangeEvent, memo, type Ref } from 'react';

import { SearchIcon } from '@air/design-icons';

export type WorkspaceAgentActionsMenuSearchFieldProps = {
  inputRef: Ref<HTMLInputElement>;
  onQueryChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  query: string;
};

export const WorkspaceAgentActionsMenuSearchField = memo(
  ({ inputRef, onQueryChange, placeholder, query }: WorkspaceAgentActionsMenuSearchFieldProps) => {
    return (
      <label className="flex shrink-0 items-center gap-2 ads:border-default border-gray-4 border-b ads:bg-base bg-gray-1 px-3 py-3 ads:text-icon-default text-gray-10 dark:bg-gray-3">
        <SearchIcon aria-hidden size="sm" />
        <span className="sr-only">{placeholder}</span>
        <input
          className="w-full bg-transparent ads:text-primary text-12 text-gray-12 leading-4 outline-none ads:placeholder:text-placeholder placeholder:text-gray-9"
          data-testid="WORKSPACE_AGENT_ACTIONS_MENU_SEARCH"
          onChange={onQueryChange}
          placeholder={placeholder}
          ref={inputRef}
          value={query}
        />
      </label>
    );
  },
);

WorkspaceAgentActionsMenuSearchField.displayName = 'WorkspaceAgentActionsMenuSearchField';
